import type { TenantStatus } from './api';

/** Rótulos e cores dos estados de assinatura, usados na página e no banner. */
export const STATUS_LABELS: Record<TenantStatus, string> = {
  pending_payment: 'Aguardando pagamento',
  active: 'Ativa',
  past_due: 'Pagamento em atraso',
  suspended: 'Acesso suspenso',
  cancelled: 'Cancelada',
};

export type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'success' | 'warning' | 'info';

export const STATUS_VARIANT: Record<TenantStatus, BadgeVariant> = {
  pending_payment: 'warning',
  active: 'success',
  past_due: 'warning',
  suspended: 'destructive',
  cancelled: 'secondary',
};

export const INVOICE_STATUS_LABELS: Record<string, string> = {
  pending: 'Aguardando',
  confirmed: 'Confirmada',
  received: 'Paga',
  overdue: 'Vencida',
  refunded: 'Estornada',
  cancelled: 'Cancelada',
};

export const INVOICE_STATUS_VARIANT: Record<string, BadgeVariant> = {
  pending: 'secondary',
  confirmed: 'info',
  received: 'success',
  overdue: 'destructive',
  refunded: 'warning',
  cancelled: 'secondary',
};

export const BILLING_TYPE_LABELS: Record<string, string> = {
  BOLETO: 'Boleto',
  PIX: 'Pix',
  CREDIT_CARD: 'Cartão de crédito',
  UNDEFINED: 'Cliente escolhe',
};
